import {Component, OnInit} from '@angular/core';
import {ItemsService} from "../../core/http/items.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ItemDetailsPopupComponent} from "../manage-items/item-details-popup/item-details-popup.component";
import {Category} from "../../shared/models/category";
import {CategoryDetailsPopupComponent} from "./category-details-popup/category-details-popup.component";
import {YesNoModalComponent} from "../../shared/components/yes-no-modal/yes-no-modal.component";

@Component({
  selector: 'app-category-overview',
  templateUrl: './category-overview.component.html',
  styleUrl: './category-overview.component.scss'
})
export class CategoryOverviewComponent implements OnInit {

  categories: Category[] = [];
  displayedColumns: string[] = ['identifier', 'text', 'sortId', 'showOnFrontend', 'allowComment', 'details', 'delete'];

  constructor(private itemsService: ItemsService, private dialog: MatDialog, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.itemsService.getAllTenantCategories().subscribe({
      next: (response) => {
        this.categories = <Category[]> response;
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  showCategoryDetails(category: Category): void {
    this.dialog.open(CategoryDetailsPopupComponent, {
      data: {
        category: category,
        new: false
      }, // Pass the positions data to the popup component
      width: '600px', // Set the width of the popup as per your preference
      panelClass: 'ordermate-dialog-panel'
    }).afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        result.guid = category.guid;
        //result.text = category.text;
        this.itemsService.updateCategory(result).subscribe({
          next: (response) => {
            this._snackBar.open('Kategorie geändert', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
          error: (error) => {
            console.log(error);
          }
        });
      }
    });
  }

  createCategory(): void {
    this.dialog.open(CategoryDetailsPopupComponent, {
      data: {
        category: {},
        new: true
      }, // Pass the positions data to the popup component
      width: '600px', // Set the width of the popup as per your preference
      panelClass: 'ordermate-dialog-panel'
    }).afterClosed().subscribe(result => {
      // console.log(result)
      if (result) {
        this.itemsService.createCategory(result).subscribe({
          next: (response) => {
            this._snackBar.open('Kategorie erstellt', 'Schließen', {duration: 3000});
            this.ngOnInit();
          },
          error: (error) => {
            console.log(error);
          }
        });
      }
    });
  }

  deleteCategory(category: Category): void {
    this.dialog.open(YesNoModalComponent, {
      data: category.identifier,
      width: '400px'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.itemsService.deleteCategory(category.guid).subscribe(result => {
          this._snackBar.open('Kategorie ' + category.identifier + ' gelöscht', 'Schließen', {duration: 3000});
          this.ngOnInit();
        });
      }
    });
  }

}
